// * There isn't a uniform/universal way to detect if the user is browsing a webpage from a mobile device, but this seems to work most of the time and might be enough for our case.
export const userAgentIsMobile =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLocaleLowerCase()
  ) || (window.orientation ?? -1) > -1;

export const userAgentIsAndroid =
  navigator.userAgent.toLocaleLowerCase().includes("android") || undefined;

export const userAgentIsIOS = 
  /iphone|ipad|ipod/i.test(navigator.userAgent.toLocaleLowerCase()) ||
  // iPad on iOS 13+ detection (reports as Mac but has touch)
  (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
  // Check platform for older iOS versions
  ['iPad', 'iPhone', 'iPod', 'iPad Simulator', 'iPhone Simulator', 'iPod Simulator'].includes(navigator.platform) ||
  undefined;

export enum Browser {
  Opera = 'Opera',
  Edge = 'Edge',
  Chrome = 'Chrome',
  Safari = 'Safari',
  Firefox = 'Firefox',
  IE = 'IE',
  Unknown = 'Unknown',
  Telegram = 'Telegram',
  Arc = 'Arc',
  Brave = 'Brave'
}

export function getBrowser(): Browser {
  try {
  const ua = navigator.userAgent;
  
  // Telegram WebView
  if (typeof (window as any)?.TelegramWebview !== 'undefined' || 
      typeof (window as any)?.TelegramWebviewProxyProto !== 'undefined' || 
      typeof (window as any)?.TelegramWebviewProxy !== 'undefined') {
    return Browser.Telegram;
  }
  
  // Brave (has specific navigator.brave object)
  if ((navigator as any).brave?.isBrave) {
    return Browser.Brave;
  }
  
  // Opera
  if (ua.includes("Opera") || ua.includes("OPR")) {
    return Browser.Opera;
  }
  
  // Edge
  if (ua.includes("Edg")) {
    return Browser.Edge;
  }
  
  // Chrome (including iOS Chrome)
  if (ua.includes("Chrome") || ua.includes("CriOS")) {
    return Browser.Chrome;
  }
  
  // Firefox
  if (ua.includes("Firefox")) {
    return Browser.Firefox;
  }
  
  // Internet Explorer
  if (ua.includes("MSIE") || 'documentMode' in document) {
    return Browser.IE;
  }
  
  // Safari and Safari-based browsers
  if (ua.includes("Safari")) {
    if (userAgentIsIOS) {
      // Check for in-app browsers first
      const inAppBrowsers = ["Instagram", "FBAN", "FBAV", "Twitter", "LinkedInApp", "Line", "WeChat"];
      const isInAppBrowser = inAppBrowsers.some(app => ua.includes(app));
      
      if (!isInAppBrowser) {
        return Browser.Safari;
      }
    } else {
      return Browser.Safari;
    }
  }
  } catch (error) {
    console.error("Error getting browser:", error);
  }
  return Browser.Unknown;
}

export function shouldOpenInSafari(): boolean {
  if (!userAgentIsIOS) {
    return false;
  }
  return getBrowser() !== Browser.Safari && getBrowser() !== Browser.Brave;
}